import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Icon } from '@malirang/front-share';

@Component({
  selector: 'app-segment-tab',
  standalone: true,
  imports: [CommonModule, RouterModule, Icon],
  templateUrl: './segment-tab.component.html',
  styleUrl: './segment-tab.component.scss',
})
export class SegmentTabComponent {
  label = input<string | undefined>(undefined);
  value = input<string | undefined>(undefined);
  count = input<number | undefined>(undefined);
  icon = input<string>('');
  expand = input<boolean>(false);

  active = input<boolean>(false);
}
